export const stageEnums = {
  start: 'START',
  insertIMEI: 'INSERTIMEI',
  selectSubscriber: 'SELECTSUBSCRIBER',
  identification: 'IDENTIFICATION',
  error: 'ERROR',
  active: 'ACTIVE',
  notSupported: 'NOTSUPPORTED',
  inactive: 'INACTIVE',
  installed: 'INSTALLED',
  callback: 'CALLBACK',
};

export const androidSVG = `<svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
<circle cx='16.125' cy='15.125' r='1.125' fill='var(--theme-primary, #810ea9)' />
<circle cx='9.375' cy='15.125' r='1.125' fill='var(--theme-primary, #810ea9)' />
<path
  clipRule='evenodd'
  d='M3 18.5v-2.144c0-5.389 4.327-9.837 9.716-9.856a9.75 9.75 0 0 1 9.784 9.75v2.25a.75.75 0 0 1-.75.75h-18A.75.75 0 0 1 3 18.5z'
  stroke='var(--theme-primary, #810ea9)'
  strokeWidth='1.5'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
<path
  d='m3.75 5.75 2.913 2.913M21.75 5.75l-2.896 2.897'
  stroke='var(--theme-primary, #810ea9)'
  strokeWidth='1.5'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
</svg>`;

export const iosSVG = `<svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path d='M13.7 3.547a3.001 3.001 0 0 1 2.8-1.922' stroke='var(--theme-primary, #810ea9)' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
<path
  clipRule='evenodd'
  d='M21.235 15.775c-.616 1.506-1.496 2.798-2.45 3.687-.872.811-1.806 1.288-2.66 1.288h-6.75c-2.625 0-6-4.5-6-9.375a5.625 5.625 0 0 1 9.375-4.192h0a5.626 5.626 0 0 1 8.172.715h0a4.501 4.501 0 0 0 .313 7.877h0z'
  stroke='var(--theme-primary, #810ea9)'
  strokeWidth='1.5'
  strokeLinecap='round'
  strokeLinejoin='round'
/>
</svg>`;
